// React
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

// components
import Body from './main/Body';

// CSS
import 'semantic-ui-css/semantic.min.css';

// store
import StoreProvider from './store/StoreProvider';

// data
import DataLayer from './data/DataLayer';

// firebase
// eslint-disable-next-line import/order
import firebase from 'firebase/app';
import firebaseConfig from './config/config-firebase';

firebase.initializeApp(firebaseConfig);

// main
function App() {
	// 使用 BrowserRouter 建立 history object
	return (
		/* 在最上層提供 global store */
		<StoreProvider>
			<BrowserRouter>
				<div id="id_wrapper">
					{/* 載入資料相關區 */}
					<DataLayer />
					{/* 頁面頂層連結區, 如要變更內容請至 APP-layout.js */}
					{/* 頁面跳轉處理區, 如要變更內容請至 APP-layout.js */}
					<Body />
				</div>
			</BrowserRouter>
		</StoreProvider>
	);
}

export default App;
